export const RESTAURANT_CDN_URL =
    'https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/';
export const MENU_API =
    'https://thingproxy.freeboard.io/fetch/https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=17.5248148&lng=78.4497875&restaurantId=';

export const RESTAURANTS_URL =
    'https://thingproxy.freeboard.io/fetch/https://www.swiggy.com/dapi/restaurants/list/v5?lat=17.5248148&lng=78.4497875&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING';

export const CATEGORY_CDN_URL =
    'https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_208,h_208,c_fit/';

export const COLLECTIONS =
    'https://thingproxy.freeboard.io/fetch/https://www.swiggy.com/dapi/restaurants/list/v5?lat=17.5291783&lng=78.44819559999999&collection=';
// 83649 & tags=layout_CCS_Biryani & sortBy=& filters=& type=rcv2 & offset=0 & page_type=null';

// export const MENU_API  =
//   "https://api.allorigins.win/raw?url=https%3A%2F%2Fwww.swiggy.com%2Fdapi%2Fmenu%2Fpl%3Fpage-type%3DREGULAR_MENU%26complete-menu%3Dtrue%26lat%3D15.8323892%26lng%3D78.0544946%26restaurantId%3D&restaurantId=";

// export const RESTAURANTS_URL=
// "https://api.allorigins.win/raw?url=https%3A%2F%2Fwww.swiggy.com%2Fdapi%2Frestaurants%2Flist%2Fv5%3Flat%3D15.8323892%26lng%3D78.0544946%26is-seo-homepage-enabled%3Dtrue%26page_type%3DDESKTOP_WEB_LISTING";
